export default "__VITE_ASSET__DZAEIWye__"